var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.496 8.96631C7.36138 6.84655 10.6057 5.44907 12.2291 4.77387C16.864 2.84606 17.827 2.51118 18.4548 2.50012C18.5928 2.49769 18.9015 2.5319 19.1015 2.69416C19.2703 2.83116 19.3168 3.01624 19.339 3.14613C19.3613 3.27603 19.3889 3.57194 19.3669 3.80315C19.1158 6.44218 18.029 12.8464 17.4761 15.8022C17.2421 17.0529 16.7815 17.4722 16.3355 17.5133C15.3663 17.6024 14.6303 16.8727 13.6916 16.2574C12.2227 15.2945 11.3929 14.6951 9.96703 13.7555C8.31923 12.6696 9.38743 12.0728 10.3265 11.0975C10.5723 10.8422 14.8426 6.95803 14.9252 6.60567C14.9356 6.5616 14.9452 6.39734 14.8476 6.3106C14.75 6.22386 14.606 6.25352 14.502 6.27711C14.3547 6.31055 12.0081 7.86156 7.46222 10.9302C6.79614 11.3875 6.19283 11.6104 5.65229 11.5987C5.05638 11.5858 3.91009 11.2618 3.05795 10.9848C2.01275 10.645 1.18206 10.4654 1.25439 9.88839C1.29207 9.58785 1.70594 9.28049 2.496 8.96631Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.558c0d6631727a37a6eb2b74330344af.svg";
export { ForwardRef as ReactComponent };